import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-product-advice-view',
  templateUrl: './product-advice-view.component.html',
  styleUrls: ['./product-advice-view.component.css']
})
export class ProductAdviceViewComponent implements OnInit {

constructor(private AdviceService:ServiceService) { }
name=""
output:any=[];
AdviceId=""
//-------date formating-------------
today: Date = new Date();
pipe = new DatePipe('en-US');
todayWithPipe:any= null;

DateFormat(value:any){
  //-------date formating----------------------
  this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
  return this.todayWithPipe
}
  ngOnInit(): void {

    this.AdviceId=this.AdviceService.GetAdviceId();
    console.log("Advice id=",this.AdviceId);
    this.AdviceService.GetAdviceDetails(this.AdviceId).subscribe((res)=>{
      this.output=res.data
      })
  }

}
